
import React, { useState } from "react";
import {
  TextField,
  Typography,
  Box,
  Divider,
  Grid,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FIELD_TYPES } from "../../../lib/field-types";

export default function FieldPalette({ onAddField }) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredFields = Object.values(FIELD_TYPES).filter((field) =>
    field.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const basicFields = filteredFields.filter(
    (field) => field.category === "basic"
  );
  const selectionFields = filteredFields.filter(
    (field) => field.category === "selection"
  );
  const advancedFields = filteredFields.filter(
    (field) => field.category === "advanced"
  );

  const handleFieldClick = (fieldType) => {
    onAddField(fieldType);
  };

  const renderFieldCategory = (title, fields) => (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {title}
      </Typography>
      <Grid container spacing={1}>
        {fields.map((field) => (
          <Grid item xs={6} key={field.type}>
            <Paper
              elevation={1}
              onClick={() => handleFieldClick(field.type)}
              sx={{
                p: 1.5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ddd",
                borderRadius: 1,
                cursor: "pointer",
                "&:hover": {
                  borderColor: "#1976d2",
                  backgroundColor: "#e3f2fd",
                },
                transition: "0.2s",
              }}
            >
              <field.icon style={{ width: 18, height: 18, color: "#555", marginBottom: 4 }} />
              <Typography variant="caption" fontWeight={500}>
                {field.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <Box
      sx={{
        width: 240,
        backgroundColor: "#fff",
        borderRight: "1px solid #e0e0e0",
        p: 2,
        height: "100%",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Form Fields
      </Typography>

      {/* Search Field */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <SearchIcon sx={{ position: "absolute", ml: 1, color: "gray", width: 18, height: 18 }} />
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search fields..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
          sx={{ pl: 3 }}
        />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {renderFieldCategory("Basic Fields", basicFields)}
        {renderFieldCategory("Selection Fields", selectionFields)}
        {renderFieldCategory("Advanced Fields", advancedFields)}
      </Box>
    </Box>
  );
}
